import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "medsurf-slide-wysiwyg-interactive-areas",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./interactive-areas.component.html",
  styleUrls: ["./interactive-areas.component.scss"],
  standalone: false,
})
export class InteractiveAreasComponent {
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public translate: TranslateService) {}

  handleClick(group: FlatModels.GroupEntityModels.Group) {
    this.slideAuthorFacade
      .requestSetAnnotationId(group.id, "annotation")
      .subscribe({
        error: (result) => {
          this.alertControlFacade.requestAddError(result);
        },
      });
  }
}
